// extracted by mini-css-extract-plugin
export default {"reservationDetails":"GuestDetailsButton_reservationDetails__619ge"};